/**
 * CorrigoPro desktop deep-link for a work order.
 * Filter uses the external (Corrigo) work order number, e.g. C5030463-00642.
 *
 * Host is tenant-specific today (am-desktop). Move to a company setting
 * if other tenants need a different Corrigo desktop host.
 */
const CORRIGO_DESKTOP_BASE_URL = 'https://am-desktop.corrigopro.com/ServiceChat/Chat/ReRoute';

export const buildCorrigoWorkOrderUrl = (externalWorkOrderNumber: string): string => {
  const filter = externalWorkOrderNumber.trim();
  return `${CORRIGO_DESKTOP_BASE_URL}?Filter=${encodeURIComponent(filter)}`;
};
